import { styled, Tooltip, tooltipClasses } from '@mui/material';

const LightTooltip = styled(({ className, slotProps, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      ...slotProps,
      popper: {
        ...slotProps?.popper,
        sx: {
          [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]:
            {
              marginTop: '4px',
            },
          [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
            {
              marginBottom: '2px',
            },
          [`&.${tooltipClasses.popper}[data-popper-placement*="right"] .${tooltipClasses.tooltip}`]:
            {
              marginLeft: '0px',
            },
          [`&.${tooltipClasses.popper}[data-popper-placement*="left"] .${tooltipClasses.tooltip}`]:
            {
              marginRight: '0px',
            },
          // Callers may pass their own popper sx (e.g. an extra box-shadow); merge rather than clobber.
          ...slotProps?.popper?.sx,
        },
      },
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    border: '1px solid #D2D2D2',
    borderRadius: '7px',
    fontSize: `0.75rem`,
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
    '&::before': {
      backgroundColor: theme.palette.common.white,
      color: '#D2D2D2',
      border: '1px solid',
    },
  },
}));

export default LightTooltip;
